import { render, staticRenderFns } from "./asideIconMenu.vue?vue&type=template&id=a9bf8fb0&scoped=true"
import script from "./asideIconMenu.vue?vue&type=script&lang=js"
export * from "./asideIconMenu.vue?vue&type=script&lang=js"
import style0 from "./asideIconMenu.vue?vue&type=style&index=0&id=a9bf8fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bf8fb0",
  null
  
)

export default component.exports